module.exports = __webpack_public_path__ + "static/js/gif.worker.a72858524bf6bbbac595f0aff4b3471a.js";